import {Injectable} from '@angular/core';

@Injectable()
export class AppConstants {
    static WITHDRAW_REQUEST_STATUSES = [
        {'name': 'Pending', 'value': 'PENDING'},
        {'name': 'Processed', 'value': 'PROCESSED'},
        {'name': 'Rejected', 'value': 'REJECTED'}
    ];

    static BUCKET_URL = 'https://axico-static.s3.ap-south-1.amazonaws.com/';
}
